import { render, staticRenderFns } from "./dialogLotto.vue?vue&type=template&id=332a9ce2"
import script from "./dialogLotto.vue?vue&type=script&lang=js"
export * from "./dialogLotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports